import { FullLandingCmsData } from "./LandingModel";

export const mockLandingData: FullLandingCmsData = {
  tickerItems: [
    "Aesthetic Treatments", "IV Therapy", "Massage & Bodywork", "Laser & Light Therapy",
    "Injectables", "Skincare & Facials", "Hormone Therapy", "Medical-Grade Peels",
    "Lash & Brow", "Hair Removal", "Body Contouring", "Microneedling"
  ],
  categories: [
    {
      icon: "🌿",
      name: "Beauty",
      description: "Facials, light peels, surface microneedling, LED, waxing, lashes, hair, nails & massage.",
      credential: "Esthetics / cosmetology license",
      color: "#2E7D32",
      bgColor: "#E8F5E9"
    },
    {
      icon: "✨",
      name: "Advanced",
      description: "Medical-grade peels, deeper microneedling, clinical LED, and laser & light therapy.",
      credential: "Advanced / laser certification",
      color: "#00838F",
      bgColor: "#E0F7FA"
    },
    {
      icon: "🩺",
      name: "Medical",
      description: "Tox, dermal fillers, and other injectables — performed under clinical oversight.",
      credential: "Clinical license + medical director",
      color: "#E65100",
      bgColor: "#FFF3E0"
    },
    {
      icon: "💧",
      name: "Wellness & IV",
      description: "IV hydration, vitamin injections, weight management, hormone therapy & PRP/PRF.",
      credential: "Clinical license + medical oversight",
      color: "#1565C0",
      bgColor: "#E3F2FD"
    }
  ],
  valueProps: [
    { icon: "💚", title: "Get discovered", description: "New local clients find you on the Tullu marketplace and book in a tap — and your Verified badge shows them you’re licensed and real." },
    { icon: "💵", title: "Keep 100%, paid fast", description: "You’re the merchant of record. No Tullu commission on your bookings; your money settles to Stripe after each visit — no net-30." },
    { icon: "📅", title: "Booking that runs itself", description: "Clients book online; auto-accept or approve each one. Buffers, notice, travel zones, and one calendar that never double-books." },
    { icon: "🗂️", title: "Charting & compliance, built in", description: "The right consent and vitals are required for each treatment, health flags raise automatically, and every treatment is charted — signed and timestamped." },
    { icon: "👥", title: "Clients & messaging", description: "Full client records — visits, notes, photos — plus in-app messaging that keeps every conversation in one place." },
    { icon: "🔁", title: "Memberships & marketing", description: "Recurring revenue you keep 100% of, plus deals, vouchers, and SMS & email campaigns to fill your calendar." },
    { icon: "🛍️", title: "Sell products", description: "Retail, professional, even Rx where you’re licensed — sold right alongside your services." },
    { icon: "🏢", title: "Team & multi-location", description: "Add staff with automatic license checks, set how bookings route (assignment or provider-choice), and run one location or many." }
  ],
  plans: [
    {
      name: "Solo",
      tagline: "For independent practitioners building their own practice",
      personas: "Aestheticians · nurse injectors · massage therapists · mobile IV",
      price: "$199",
      pricePeriod: "/mo",
      trialNote: "14-day free trial",
      features: [
        "1 provider profile with direct payouts",
        "Unlimited services & bookings",
        "Calendar, coverage zones & buffer rules",
        "Consent forms, vitals gate & client history",
        "Stripe payouts & earnings dashboard",
        "Google & iCal sync"
      ],
      feeNote: "No per-booking commission · keep 100%",
      isFeatured: false,
      accentColor: "#1D9E75"
    },
    {
      name: "Business",
      tagline: "For owner-operators running a team at one location",
      personas: "Med spas · wellness clinics · salon teams · owner-operators",
      price: "$499",
      pricePeriod: "/mo",
      trialNote: "14-day free trial",
      features: [
        "Everything in Solo, plus:",
        "All active providers included — no per-seat fees",
        "Assignment-based & provider-choice routing",
        "Staff onboarding with automatic credential checks",
        "Team-wide client history & business analytics",
        "Branded business profile & team management"
      ],
      feeNote: "No per-booking commission · keep 100%",
      isFeatured: true,
      accentColor: "#1D9E75"
    },
    {
      name: "Enterprise",
      tagline: "For multi-location groups, franchises & networks",
      personas: "Regional chains · franchises · DSOs · medspa networks",
      price: "$449",
      pricePeriod: "/location",
      trialNote: "+ custom base · billed annually · volume pricing",
      features: [
        "Everything in Business, plus:",
        "Unlimited locations with per-location billing",
        "Cross-location staff pools & routing",
        "Org-wide analytics with per-site drill-down",
        "Dedicated account manager & priority SLA"
      ],
      feeNote: "No per-booking commission · keep 100%",
      isFeatured: false,
      accentColor: "#C87B0A"
    }
  ],
  testimonials: [
   {
  stars: 5,
  quoteStart: `"I've tried three booking platforms. What sets Tullu apart: `,
  quoteHighlight: "the clinical side is actually built in",
  quoteEnd: " — consent, flags, health intake, not duct-taped together with PDFs.\"",
  avatarText: "MR",
  name: "Maria R.",
  credentials: "NP · Aesthetic Injectables · Scottsdale, AZ",
  badgeText: "Solo",
  badgeClass: "bg-[#E8F5F0] text-[#0D5C42]"
},
   {
  stars: 5,
  quoteStart: `"Eight providers, and the routing is exactly what we needed — assignment-based keeps quality tight. `,
  quoteHighlight: "The team dashboard alone replaced two other tools",
  quoteEnd: ` we were paying for."`,
  avatarText: "JK",
  name: "James K.",
  credentials: "Owner · Radiance Medical Spa · Phoenix, AZ",
  badgeText: "Business",
  badgeClass: "bg-[#EFF6FF] text-[#2563EB]"
},
{
  stars: 5,
  quoteStart: `"Mobile IV is notoriously hard to manage — coverage zones, travel fees, same-day vs scheduled. `,
  quoteHighlight: "Tullu handles it all out of the box",
  quoteEnd: `; first booking came the same week."`,
  avatarText: "AT",
  name: "Aisha T.",
  credentials: "RN · Mobile IV Therapy · Austin, TX",
  badgeText: "Solo",
  badgeClass: "bg-[#E8F5F0] text-[#0D5C42]"
},
  ],
  faqs: [
    {
      question: "Who can apply as a Tullu partner?",
      answer: "Any licensed beauty, wellness, or medical professional practicing in Arizona — Tullu is Arizona-first, with more states on the way. This includes solo practitioners (estheticians, nurse injectors, massage therapists, mobile IV providers) and businesses running a team. At minimum, every provider holds a valid state license. Additional credentials — such as NPI, DEA registration, or specialty certifications — are required only where your service category calls for them."
    },
    {
      question: "How does credential verification work?",
      answer: "After you submit, most credentials verify automatically and clear within minutes. At minimum, every provider holds a valid state license; depending on what you offer, we may also verify an NPI, DEA registration, or specialty certifications — but only when they apply to you. Anything that needs a closer look — an expired or mismatched record, or an uploaded certificate like a laser cert — is reviewed by our team, usually within <strong>one business day</strong>. You'll be notified by email and in-app at each stage. Once approved, your service categories unlock automatically based on what your credentials authorize."
    },
    {
      question: "How and when do I get paid?",
      answer: "You connect a Stripe account during setup — you're the merchant of record on every transaction. Clients pay at booking checkout; funds settle to your Stripe account after service completion. Your plan is billed as a flat monthly subscription, and you keep 100% of your service revenue — there's no per-booking commission. Payout timing follows Stripe's standard schedule (typically 2 business days after settlement)."
    },
    {
      question: "Do I control my own schedule?",
      answer: "Completely. You set your working hours, buffer time between bookings, advance notice requirements, and any blackout dates. For mobile providers, you define your coverage zones and travel radius. Clients can only book within windows you've explicitly opened."
    },
    {
      question: "What's the difference between Solo, Business, and Enterprise?",
      answer: "<strong>Solo</strong> is for individual practitioners — one profile, your own payouts, no staff to manage. <strong>Business</strong> is for owner-operators with a team at one location — you invite providers, set booking routing rules, and manage everything under your brand. <strong>Enterprise</strong> is for two or more locations, with per-location staff, centralized or delegated admin, and org-wide reporting."
    },
    {
      question: "Can I offer same-day bookings, not just scheduled appointments?",
      answer: "Yes. Tullu supports both scheduled bookings (clients pick a time slot in advance) and same-day bookings (clients request a time today, you accept or decline in real time). You can configure each service independently — some as scheduled-only, others as same-day, or both."
    },
    {
      question: "What happens if I cancel my subscription?",
      answer: "You keep full access until the end of your current billing period. After that, your profile is <strong>paused — not deleted</strong>. Your service menu, client history, credentials, and settings are all preserved. You can reactivate at any time and pick up exactly where you left off."
    }
  ]
};